
import SelectB from '../selectorB/index.jsx'
import SelectB_Item from '../selectorB/item.jsx'
import SetColor from '../setColor/index.jsx'
import Slider from '../slider/index.jsx'
import { useState } from 'react'
import './side.less'
import { Editor } from '@tinymce/tinymce-react'
import React from 'react'
const te = ['left', 'center', 'right']
console.log(React, te)
export default function BasicsTextSide(props) {
  const [ifon, setIfon] = useState({
    editor: null,
    options: [{
      id: 0,
      text: '无',
      src: 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/border-none.png'
    }, {
      id: 1,
      text: '小点',
      src: 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/border-dott.png'
    }, {
      id: 2,
      text: '实线',
      src: 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/border-solid.png'
    }, {
      id: 3,
      text: '大点',
      src: 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/border-dashed.png'
    }, {
      id: 4,
      text: '双实线',
      src: 'https://i.gtimg.cn/qzone/biz/gdt/promotion/pages/landingpage/pagemaker/images/border-dobbule-solid.png'
    }]
  })

  window.editor = ifon

  return (<div className='BasicsTextSide'>

    <div className='BasicsTextSide_no1'>
      <h3 className='no1_title'>文本</h3>
      <div className='no1_box'>
        <Editor
          init={{
            height: 500,
            language: 'zh_CN',
            menubar: false,
            branding: false,
            elementpath: false,
            resize: false,
            style_formats_autohide: false,
            plugins: ['emoticons',
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar_mode: 'wrap',
            // eslint-disable-next-line no-multi-str
            toolbar: 'undo redo | fontsizeselect | indent outdent | lineheight  |fontselect  | bold italic backcolor forecolor | \ alignleft aligncenter alignright alignjustify | removeformat | underline \
             bullist numlist emoticons | autolink lists link',
            max_width: '100%',
            max_height: 450
          }}

          onInit={(content, editor) => {
            setTimeout(() => {
              editor.setContent(props.ifon.html)
            }, 100)

            setIfon({
              ...ifon,
              editor: editor
            })
          }}
          onEditorChange={(content, editor) => {
            props.ifon.html = content
            props.mySetIfon(props.ifon)
          }}
        />
      </div>

      <div className='no1_Box'>
        <span className='Box_title'>文本颜色</span>
        <div className='Box_main'>
          <SetColor color={props.ifon.color} setColor={(obj) => {
            props.ifon.color = obj.hex
            props.mySetIfon(props.ifon)
          }}></SetColor>
        </div>
      </div>

      <div className='no1_Box'>
        <span className='Box_title'>边距</span>
        <div className='Box_main'>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.paddingTop} maxValue={50} change={(value) => {
              props.ifon.paddingTop = value
              props.mySetIfon(props.ifon)
            }}>上</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.paddingBottom} maxValue={50} change={(value) => {
              props.ifon.paddingBottom = value
              props.mySetIfon(props.ifon)
            }}>下</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.paddingLeft} change={(value) => {
              props.ifon.paddingLeft = value
              props.mySetIfon(props.ifon)
            }}>左</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.paddingRight} change={(value) => {
              props.ifon.paddingRight = value
              props.mySetIfon(props.ifon)
            }}>右</Slider>
          </div>
        </div>
      </div>

      <div className='no1_Box'>
        <span className='Box_title'>文字边框</span>
        <div className='Box_main'>
          <div className={`switch ${props.ifon.isFrame ? 'open' : ''}`}>
            <i className='switch_icon' onClick={() => {
              props.ifon.isFrame = !props.ifon.isFrame
              props.mySetIfon(props.ifon)
            }}></i>
          </div>
        </div>
      </div>

      {props.ifon.isFrame && <div className='no1_Box'>
        <span className='Box_title'>样式</span>
        <div className='Box_main'>
          <SelectB options={ifon.options} id={props.ifon.textStyle} onChange={(id) => {
            props.ifon.textStyle = id
            props.mySetIfon(props.ifon)
          }}>
            {ifon.options ? ifon.options.map((item) => {
              return <SelectB_Item id={item.id} key={item.id}>{<img src={item.src} style={{ width: '100%', height: '100%' }} />}</SelectB_Item>
            }) : null}
          </SelectB>
        </div>
      </div>}

      {props.ifon.isFrame && <div className='no1_Box'>
        <span className='Box_title'>边框颜色</span>
        <div className='Box_main'>
          <SetColor color={props.ifon.frameColor} setColor={(obj) => {
            props.ifon.frameColor = obj.hex
            props.mySetIfon(props.ifon)
          }}></SetColor>
        </div>
      </div>}

      {props.ifon.isFrame && <div className='no1_Box'>
        <span className='Box_title'>尺寸</span>
        <div className='Box_main'>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.thickness} maxValue={10} change={(value) => {
              props.ifon.thickness = value
              props.mySetIfon(props.ifon)
            }}>粗细</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.fillet} maxValue={10} change={(value) => {
              props.ifon.fillet = value
              props.mySetIfon(props.ifon)
            }}>圆角</Slider>
          </div>
        </div>
      </div>}

      {props.ifon.isFrame && <div className='no1_Box'>
        <span className='Box_title'>边框边距</span>
        <div className='Box_main'>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.framePaddingTop} change={(value) => {
              props.ifon.framePaddingTop = value
              props.mySetIfon(props.ifon)
            }}>上</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.framePaddingBottom} change={(value) => {
              props.ifon.framePaddingBottom = value
              props.mySetIfon(props.ifon)
            }}>下</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.framePaddingLeft} change={(value) => {
              props.ifon.framePaddingLeft = value
              props.mySetIfon(props.ifon)
            }}>左</Slider>
          </div>
          <div className='main_item'>
            <Slider defaultValue={props.ifon.framePaddingRight} change={(value) => {
              props.ifon.framePaddingRight = value
              props.mySetIfon(props.ifon)
            }}>右</Slider>
          </div>
        </div>
      </div>}

    </div>

  </div>)
}
